import { createStyles, makeStyles, Typography } from "@material-ui/core";
import boxImage from "assets/images/group-14.png";
import { Button } from "ui/Button";
import React from "react";
import "styled-components/macro";

interface TopSloganProps {
  buttonClick?: (e: any) => void;
  buttonTitle?: string;
  messageH3?: string;
  messageH1?: string;
  illustration?: string;
  disabled?: boolean;
  CustomButton?: any;
}

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: "flex",
      height: 125,
      backgroundColor: "#fff",
      borderRadius: 14,
      justifyContent: "space-between",
      width: "100%",
    },
    slogan: {
      display: "flex",
      justifyContent: "space-evenly",
    },
    spacing: {
      marginTop: "auto",
      marginBottom: "auto",
      marginLeft: 15,
    },
    img: {
      objectFit: "cover",
      height: "100%",
      borderRadius: "0 14px 14px 0",
      width: "100%",
    },
    imgContent: {
      height: "100%",
      borderRadius: 14,
      width: "15rem",
    },
    h3: {
      fontSize: 26,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: 1.39,
      color: "rgba(117, 122, 147, 0.64)",
    },
    h1: {
      fontSize: 26,
      fontWeight: 900,
      lineHeight: 1.39,
      color: "rgba(117, 122, 147, 0.64)",
    },
  })
);
// under construction.
export function TopSlogan({
  buttonClick,
  messageH1 = "convenient delivery.",
  messageH3 = "Choose the most",
  illustration = boxImage,
  buttonTitle = "add",
  disabled = false,
  CustomButton,
}: TopSloganProps) {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <div className={styles.slogan}>
        <div
          className={styles.spacing}
          style={{
            display: buttonClick || CustomButton ? "initial" : "none",
          }}
        >
          {CustomButton ? (
            <CustomButton />
          ) : (
            <Button
              disabled={disabled}
              color="primary"
              variant="contained"
              css={`
                &.MuiButton-root {
                  width: auto;
                  border-radius: 4px;
                  box-shadow: 4px 2px 9px 0 rgba(0, 0, 0, 0.23);
                }
              `}
              onClick={buttonClick}
            >
              {buttonTitle}
            </Button>
          )}
        </div>
        <div className={styles.spacing}>
          <Typography variant="h3" className={styles.h3}>
            {messageH3}
          </Typography>
        </div>
        <div className={styles.spacing}>
          <Typography variant="h1" className={styles.h1}>
            {messageH1}
          </Typography>
        </div>
      </div>
      <div className={styles.imgContent}>
        <img src={illustration} className={styles.img} alt="box images" />
      </div>
    </div>
  );
}
